"use client"

import { useEffect, useRef, useState, useCallback } from "react"
import { Link, Navigate, Outlet, useLocation, useNavigate, NavLink } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faUser,
  faHome,
  faClipboardList,
  faSignOutAlt,
  faChevronRight,
  faBars,
  faTimes,
  faBriefcase,
  faBuildingColumns,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons"
import d1 from "../logo/logo1png2.png"
import Cookies from "js-cookie"
import { useDispatch, useSelector } from "react-redux"
import "../NavbarCSS/Dummy.css"
import { logoutAsync } from "../../../../features/auth/authSlices"
import RoleBasedProtectedRoute from "../../../../features/common/RoleBasedProtectedRoute"
import { Image } from "@chakra-ui/react"
import { CANDIDATE_PROFILE } from "../../../../features/common/URLs"
import {
  fetchBasicDetailsBySingleParamAsync,
  selectBasicDetailsBySingleParam,
} from "../../../../features/profile/BasicDetailsSingleParam/BasicDetailsSingleParamSlice"
import { Bars3BottomLeftIcon } from "@heroicons/react/24/solid"

const JOBLIST_PERSIST_KEY = "jobListPersist"

export function DummyAfterLogin() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const dropdownRef = useRef(null)
  const userButtonRef = useRef(null)

  // Refs used for the jobs dropdown (currently not in use)
  // const jobsDropdownRef = useRef(null)
  // const jobsTimeoutRef = useRef(null)

  // State used for the jobs dropdown (currently not in use)
  // const [isJobsDropdownOpen, setJobsDropdownOpen] = useState(false)
  // const [activeJobsSubMenu, setActiveJobsSubMenu] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const basicDetails = useSelector(selectBasicDetailsBySingleParam)

  const hasInitiatedFetch = useRef(false)

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 20)
  }, [])

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [handleScroll])

  useEffect(() => {
    const token = Cookies.get("userToken")
    if (token && !hasInitiatedFetch.current && !basicDetails?.loading && !basicDetails?.name) {
      hasInitiatedFetch.current = true
      dispatch(fetchBasicDetailsBySingleParamAsync())
    }
  }, [dispatch, basicDetails?.loading, basicDetails?.name])

  const userData = {
    name: basicDetails?.name || "Guest",
    email: basicDetails?.email || "guest@example.com",
    profilePic: basicDetails?.basic_details?.profile_pic,
  }

  const toggleDrawer = useCallback(() => {
    setIsDrawerOpen((prev) => !prev)
  }, [])

  const toggleSidebar = useCallback(() => {
    const next = !isSidebarOpen
    setIsSidebarOpen(next)
    document.dispatchEvent(new CustomEvent("toggleSidebar", { detail: { isOpen: next } }))
  }, [isSidebarOpen])

  // Keep local toggle icon in sync if other components change it
  useEffect(() => {
    const handleExternalToggle = (e) => {
      setIsSidebarOpen(e.detail.isOpen)
    }
    document.addEventListener("toggleSidebar", handleExternalToggle)
    return () => document.removeEventListener("toggleSidebar", handleExternalToggle)
  }, [])

  const handleLogout = useCallback(async () => {
    Cookies.remove("userToken")
    await dispatch(logoutAsync())
    hasInitiatedFetch.current = false
    navigate("/")
    window.location.reload()
    setIsDrawerOpen(false)
  }, [dispatch, navigate])

  // Close user dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !userButtonRef.current?.contains(event.target)
      ) {
        setIsDrawerOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleLinkClick = useCallback(() => {
    setIsDrawerOpen(false)
  }, [])

  const showSidebarToggle = location.pathname.includes("/candidate-dashboard")
  

  // ===========================
  // Jobs dropdown helpers (commented out for now)
  // ===========================
  /*
  // Hardcoded job filters (unchanged logic)
  const jobTypes = [
    { value: "", label: "All Types" },
    { value: "Full Time", label: "Full Time" },
    { value: "Part Time", label: "Part Time" },
    { value: "Contract", label: "Contract" },
    { value: "Freelance", label: "Freelance" },
    { value: "Internship", label: "Internship" },
  ]

  const jobCategories = [
    { uuid: "6ab5013c-3524-4722-bf5f-e3f4ff35f93c", title: "Administrative & Management" },
    { uuid: "2f8fd065-b087-4438-92eb-6f219085be6e", title: "Customer Service" },
    { uuid: "2728c84a-a63d-46d5-b232-56bcb6373f52", title: "Finance & Accounting" },
    { uuid: "1a07d165-d156-4ca7-a2db-79c3be3c9825", title: "Human Resources (HR)" },
    { uuid: "b7883338-3b1a-4ea4-84f3-54a60c684367", title: "IT (Information Technology)" },
    { uuid: "14a5e1ed-460e-46ff-8cc9-cf8f46f0599c", title: "Legal & Compliance" },
    { uuid: "56ba641b-a11c-4c1c-ba64-c5db036536a9", title: "Marketing & Sales" },
    { uuid: "71ae4164-76d6-4f64-8dde-18dcf78b1997", title: "Operations & Production" },
    { uuid: "7a7b17b9-b3f1-4b7d-95f1-5597d911a641", title: "Others" },
    { uuid: "91ac3933-99f2-4d4f-8415-db9aa23ce591", title: "Public Relations (PR) & Communications" },
    { uuid: "091aad8c-5986-4251-a75f-e6d1f59731d1", title: "Research & Development (R&D)" },
  ]

  const jobLocations = [
    { uuid: "d9633067-a577-11ef-806e-89fb4f970b6e", title: "Bhopal" },
    { uuid: "d963424e-a577-11ef-806e-89fb4f970b6e", title: "Indore" },
    { uuid: "d963b72d-a577-11ef-806e-89fb4f970b6e", title: "Pune" },
    { uuid: "d96561b3-a577-11ef-806e-89fb4f970b6e", title: "Hyderabad" },
    { uuid: "d9659213-a577-11ef-806e-89fb4f970b6e", title: "Noida" },
    { uuid: "d9655bab-a577-11ef-806e-89fb4f970b6e", title: "Greater Noida" },
    { uuid: "d9621041-a577-11ef-806e-89fb4f970b6e", title: "Ahmedabad" },
    { uuid: "d962b588-a577-11ef-806e-89fb4f970b6e", title: "Bengaluru" },
    { uuid: "d9647349-a577-11ef-806e-89fb4f970b6e", title: "Chennai" },
    { uuid: "d963ac49-a577-11ef-806e-89fb4f970b6e", title: "Mumbai" },
    { uuid: "d964377a-a577-11ef-806e-89fb4f970b6e", title: "Jaipur" },
  ]

  const jobTitles = [
    { uuid: "31afdd79-fe5a-47d5-90c8-4f6fdd39c12e", title: "Software Developer" },
    { uuid: "041fe998-cbb8-483c-885a-9c01d1c2ca8d", title: "Full Stack Developer" },
    { uuid: "87daaf1c-a54f-4b60-acd6-5f4448790a94", title: "Android Developer" },
    { uuid: "c2ba9d18-6904-490f-99d2-917486506903", title: "iOS Developer" },
    { uuid: "96f9c59e-72e6-43dc-92d9-5a7802272ba2", title: "UI/UX Designer" },
    { uuid: "1c1bc246-3907-4789-a118-eb1b079364c5", title: "AI / Machine Learning Related" },
    { uuid: "b076e802-00c4-45e1-9a86-7e8ec17b5290", title: "Cloud Consultant (Oracle Cloud)" },
    { uuid: "00f280a5-c10f-4863-99a8-91ac9c00769d", title: "Digital Marketing Executive" },
    { uuid: "975a79c2-104b-4ac8-8e9d-8f723e1b2137", title: "HR Manager" },
    { uuid: "c8424ea1-7304-4de2-9184-cb283f6a5f72", title: "Project / Program Manager" },
  ]
  
  const handleJobSelection = (type, value, title) => {
    try { sessionStorage.removeItem(JOBLIST_PERSIST_KEY) } catch (e) { }
    const state = { fromJobSearch: true }
    switch (type) {
      case "type": state.jobType = value || ""; break
      case "location":
        if (value) {
          state.selectedLocations = [value]
          if (title) state.locationLabelMap = { [value]: title }
        }
        break
      case "title":
        if (value) state.selectedSuggestions = [{ uuid: `jt_${value}`, title: title || "" }]
        break
      case "category":
        if (value) {
          state.departmentUuid = value
          state.selectedSuggestions = []
        }
        break
      default: break
    }
    navigate("/jobs", { state })
    setJobsDropdownOpen(false)
    setActiveJobsSubMenu(null)
  }

  const renderSubMenuList = (title, items, type) => (
    <>
      <h3 className="text-sm font-semibold text-gray-900 mb-3 pb-2 border-b border-gray-200">{title}</h3>
      <div className="space-y-1">
        {items.map((item) => (
          <button
            key={item.uuid || item.value}
            onClick={() => handleJobSelection(type, item.uuid || item.value, item.title || item.label)}
            className="block w-full text-left px-2 py-1.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded transition-colors"
          >
            {item.title || item.label}
          </button>
        ))}
      </div>
    </>
  )
  */

  return (
    <div className="">
      <RoleBasedProtectedRoute onRoleCheck={() => { }}>
        {({ role }) => {
          if (role === "admin" && !location.pathname.startsWith("/admin-dashboard")) {
            return <Navigate to="/admin-dashboard" replace />
          }
          if (role === "admin" && location.pathname.startsWith("/admin-dashboard")) {
            return <Outlet />
          }

          return (
            <>
              {/* Fixed height header so sidebar can offset on mobile */}
              <header className={`sticky top-0 z-auto ${scrolled ? "bg-white shadow-sm" : "bg-white"} h-14 md:h-16`}>
                <nav className="h-full mx-auto px-3 flex justify-between items-center">
                  <div className="flex items-center">
                    {showSidebarToggle && (
                      <button
                        className="mr-1 px-2 py-1 bg-blue-500 text-white rounded lg:hidden"
                        onClick={toggleSidebar}
                        aria-label="Toggle sidebar"
                      >
                        <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
                      </button>
                    )}
                    <Link to="/" className="flex items-center">
                      <Image
                        src={d1 || "/placeholder.svg?height=40&width=40&query=company logo"}
                        className="h-12 sm:h-14 w-auto mr-2"
                        alt="Logo"
                      />
                    </Link>
                  </div>

                  {/* Top nav links for candidate */}
                  <RoleBasedProtectedRoute>
                    {({ role }) =>
                      role === "candidate" ? (
                        <div className="hidden custom:flex space-x-14">
                          <NavLink
                            to="/"
                            end
                            className={({ isActive }) =>
                              `relative text-gray-700 font-medium hover:text-blue-600 transition-colors duration-200 group ${isActive ? "text-blue-600" : ""
                              }`
                            }
                          >
                            {({ isActive }) => (
                              <>
                                Home
                                <span
                                  className={`absolute left-0 bottom-0 h-0.5 bg-yellow-400 transition-all duration-300 ${isActive ? "w-full" : "w-0 group-hover:w-full"
                                    }`}
                                />
                              </>
                            )}
                          </NavLink>

                          {/* Simple "Find Jobs" link (dropdown disabled) */}
                          <NavLink
                            to="/jobs"
                            className={({ isActive }) =>
                              `relative text-gray-700 font-medium hover:text-blue-600 transition-colors duration-200 group ${isActive ? "text-blue-600" : ""
                              }`
                            }
                          >
                            {({ isActive }) => (
                              <>
                                Find Jobs
                                <span
                                  className={`absolute left-0 bottom-0 h-0.5 bg-yellow-400 transition-all duration-300 ${isActive ? "w-full" : "w-0 group-hover:w-full"
                                    }`}
                                />
                              </>
                            )}
                          </NavLink>

                          {/* Original Find Jobs dropdown (commented out).
                              Uncomment this block AND the related state/refs/helpers at the top
                              if you want to use the dropdown again. */}
                          {/*
                          <div
                            ref={jobsDropdownRef}
                            onMouseEnter={() => {
                              if (jobsTimeoutRef.current) clearTimeout(jobsTimeoutRef.current)
                              setJobsDropdownOpen(true)
                            }}
                            onMouseLeave={() => {
                              jobsTimeoutRef.current = setTimeout(() => {
                                setJobsDropdownOpen(false)
                                setActiveJobsSubMenu(null)
                              }, 300)
                            }}
                            className="relative"
                          >
                            <NavLink
                              to="/jobs"
                              className={({ isActive }) =>
                                `relative text-gray-700 font-medium hover:text-blue-600 transition-colors duration-200 group ${
                                  isActive ? "text-blue-600" : ""
                                }`
                              }
                            >
                              {({ isActive }) => (
                                <>
                                  <span className="inline-flex items-center">
                                    Find Jobs
                                    <svg
                                      className={`ml-1 w-4 h-4 transition-transform ${
                                        isJobsDropdownOpen ? "rotate-180" : ""
                                      }`}
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                      />
                                    </svg>
                                  </span>
                                  <span
                                    className={`absolute left-0 bottom-0 h-0.5 bg-yellow-400 transition-all duration-300 ${
                                      isActive ? "w-full" : "w-0 group-hover:w-full"
                                    }`}
                                  />
                                </>
                              )}
                            </NavLink>

                            {isJobsDropdownOpen && (
                              <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 z-40">
                                <div className="flex relative">
                                  <div className="p-4 min-w-[200px]">
                                    <h3 className="text-sm font-semibold text-gray-900 mb-3 pb-2 border-b border-gray-200">
                                      Job by Type
                                    </h3>
                                    <div className="space-y-1">
                                      {jobTypes.map((type) => (
                                        <button
                                          key={type.value}
                                          onClick={() => handleJobSelection("type", type.value, type.label)}
                                          className="block w-full text-left px-2 py-1.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded transition-colors"
                                        >
                                          {type.label}
                                        </button>
                                      ))}
                                    </div>
                                  </div>

                                  <div className="p-4 min-w-[240px] border-l border-gray-200 space-y-1">
                                    {[
                                      { key: "category", label: "Job by Category" },
                                      { key: "location", label: "Job by Location" },
                                      { key: "title", label: "Job by Title" },
                                    ].map((item) => (
                                      <div
                                        key={item.key}
                                        onMouseEnter={() => setActiveJobsSubMenu(item.key)}
                                        className={`flex justify-between items-center w-full text-left p-2 text-sm text-gray-700 rounded transition-colors cursor-pointer ${
                                          activeJobsSubMenu === item.key
                                            ? "bg-blue-50 text-blue-600"
                                            : "hover:bg-gray-100"
                                        }`}
                                      >
                                        <span>{item.label}</span>
                                        <svg
                                          className="w-4 h-4 text-gray-400"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M9 5l7 7-7 7"
                                          ></path>
                                        </svg>
                                      </div>
                                    ))}
                                  </div>

                                  {activeJobsSubMenu && (
                                    <div className="absolute top-0 left-full h-full">
                                      <div className="p-4 min-w-[300px] bg-white rounded-lg shadow-xl border-l ml-2 border-t border-b border-gray-200 overflow-y-auto">
                                        {activeJobsSubMenu === "category" &&
                                          renderSubMenuList("Job by Category", jobCategories, "category")}
                                        {activeJobsSubMenu === "location" &&
                                          renderSubMenuList("Job by Location", jobLocations, "location")}
                                        {activeJobsSubMenu === "title" &&
                                          renderSubMenuList("Job by Title", jobTitles, "title")}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          */}

                          <NavLink
                            to="/company-list"
                            className={({ isActive }) =>
                              `relative text-gray-700 font-medium hover:text-blue-600 transition-colors duration-200 group ${isActive ? "text-blue-600" : ""
                              }`
                            }
                          >
                            {({ isActive }) => (
                              <>
                                Companies
                                <span
                                  className={`absolute left-0 bottom-0 h-0.5 bg-yellow-400 transition-all duration-300 ${isActive ? "w-full" : "w-0 group-hover:w-full"
                                    }`}
                                />
                              </>
                            )}
                          </NavLink>

                          <NavLink
                            to="/resume-builder"
                            className={({ isActive }) =>
                              `relative text-gray-700 font-medium hover:text-blue-600 transition-colors duration-200 group ${isActive ? "text-blue-600" : ""
                              }`
                            }
                          >
                            {({ isActive }) => (
                              <>
                                Resume Builder
                                <span
                                  className={`absolute left-0 bottom-0 h-0.5 bg-yellow-400 transition-all duration-300 ${isActive ? "w-full" : "w-0 group-hover:w-full"
                                    }`}
                                />
                              </>
                            )}
                          </NavLink>
                        </div>
                      ) : null
                    }
                  </RoleBasedProtectedRoute>

                  <div className="flex items-center space-x-4 px-2.5 py-1 rounded-3xl border-1 ">
                    <Link to="/candidate-dashboard" className="inline-flex items-center">
                      <Bars3BottomLeftIcon className="h-6 w-6 sm:h-7 sm:w-7 " />
                    </Link>

                    <div className="relative" ref={dropdownRef}>
                      <button
                        ref={userButtonRef}
                        onClick={toggleDrawer}
                        className="text-gray-600 hover:text-blue-600 transition-colors duration-200 focus:outline-none relative z-50 flex items-center justify-center"
                      >
                        {userData.profilePic ? (
                          <Image
                            src={`${CANDIDATE_PROFILE}${userData.profilePic}`}
                            className="h-7 w-7 sm:h-8 sm:w-8 object-cover rounded-full border-2 border-gray-200 hover:border-blue-300 transition-colors"
                            alt="Profile"
                          />
                        ) : (
                          <div className="h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-gray-100 border-2 border-gray-200 hover:border-blue-300 flex items-center justify-center transition-colors">
                            <FontAwesomeIcon icon={faUser} className="text-lg text-gray-600" />
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                </nav>
              </header>

              {/* Overlay for user dropdown */}
              {isDrawerOpen && (
                <div
                  className="fixed inset-0 bg-black bg-opacity-10 z-40 transition-opacity duration-300 ease-in-out"
                  onClick={() => setIsDrawerOpen(false)}
                />
              )}

              {/* User Dropdown */}
              {userData && isDrawerOpen && (
                <div
                  className="user-dropdown fixed right-4 top-12 mt-2 w-72 md:w-96 bg-white rounded-lg shadow-2xl z-50 transform transition-all duration-300 ease-in-out max-h-screen overflow-y-auto"
                  ref={dropdownRef}
                >
                  <div className="relative">
                    <div className="bg-[linear-gradient(to_bottom_right,_#1565C0,_#1E88E5,_#26C6DA)] text-white p-2.5 rounded-t-lg">
                      <div className="flex items-start space-y-1">
                        <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mr-3 shadow-md">
                          {userData.profilePic ? (
                            <Image
                              src={`${CANDIDATE_PROFILE}${userData.profilePic}`}
                              className="h-16 w-16 object-cover rounded-full"
                              alt="Profile"
                            />
                          ) : (
                            <span className="text-2xl font-bold text-blue-600">
                              {userData.name.charAt(0)}
                            </span>
                          )}
                        </div>
                        <div className="space-y-1">
                          <div className="text-xl font-semibold">{userData.name}</div>
                          <p className="text-sm text-blue-100">{userData.email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-2.5">
                      <h2 className="text-lg font-semibold mb-2 text-gray-700 border-b pb-2">
                        Account Options
                      </h2>
                      <RoleBasedProtectedRoute>
                        {({ role }) => (
                          <div className="space-y-0">
                            <Link
                              to={role === "candidate" ? "/candidate-dashboard" : "/employer-dashboard"}
                              className="flex items-center justify-between px-2 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors duration-200"
                              onClick={handleLinkClick}
                            >
                              <div className="flex items-center">
                                <FontAwesomeIcon icon={faHome} className="mr-2.5 w-5 text-blue-500" />
                                <span>My Profile</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-gray-400" />
                            </Link>
                            <Link
                              to="/jobs"
                              className="flex items-center justify-between px-2 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors duration-200"
                              onClick={handleLinkClick}
                            >
                              <div className="flex items-center">
                                <FontAwesomeIcon icon={faBriefcase} className="mr-2.5 w-5 text-blue-500" />
                                <span>All Jobs</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-gray-400" />
                            </Link>
                            <Link
                              to="/company-list"
                              className="flex items-center justify-between px-2 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors duration-200"
                              onClick={handleLinkClick}
                            >
                              <div className="flex items-center">
                                <FontAwesomeIcon
                                  icon={faBuildingColumns}
                                  className="mr-2.5 w-5 text-blue-500"
                                />
                                <span>Companies</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-gray-400" />
                            </Link>
                            <Link
                              to="/blogs"
                              className="flex items-center justify-between px-2 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors duration-200"
                              onClick={handleLinkClick}
                            >
                              <div className="flex items-center">
                                <FontAwesomeIcon
                                  icon={faNewspaper}
                                  className="mr-2.5 w-5 text-blue-500"
                                />
                                <span>Blogs</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-gray-400" />
                            </Link>
                            <Link
                              to="/candidate-dashboard/change-password"
                              className="flex items-center justify-between px-2 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors duration-200"
                              onClick={handleLinkClick}
                            >
                              <div className="flex items-center">
                                <FontAwesomeIcon
                                  icon={faClipboardList}
                                  className="mr-2.5 w-5 text-blue-500"
                                />
                                <span>Change Password</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-gray-400" />
                            </Link>
                          </div>
                        )}
                      </RoleBasedProtectedRoute>
                      <div className="mt-2.5">
                        <button
                          onClick={handleLogout}
                          className="w-full py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors duration-200 flex items-center justify-center shadow-md"
                        >
                          <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                          Logout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )
        }}
      </RoleBasedProtectedRoute>

      {/* Keep this role guard as-is */}
      <div>
        <RoleBasedProtectedRoute>
          {({ role }) => {
            if (role === "employer" && !location.pathname.startsWith("/employer-dashboard")) {
              return <Navigate to="/employer-dashboard" replace />
            }
            return null
          }}
        </RoleBasedProtectedRoute>
      </div>
    </div>
  )
}






